import React, { Component } from 'react'

export class Sarapoint extends Component {
  render() {
    return <div></div>
  }
}

export default Sarapoint
